import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam, useParseParams } from '@hooks/params';
import { findHealthQuoteParamsSchema } from '@apis/HealthQuoteApi';

import { healthQuoteFetch, HealthQuoteFetchPayload, healthQuoteFind, HealthQuoteFindPayload } from './action';
import { selectHealthQuoteBuyRoute } from './selector';
import { HealthQuoteBuyNewPageParams } from './route';

export const useHealthQuoteBuyNewPageParams = () =>
  useParseParams<HealthQuoteBuyNewPageParams>(findHealthQuoteParamsSchema);

export const useHealthQuoteFind = () => {
  const dispatch = useDispatch();
  const params = useHealthQuoteBuyNewPageParams();
  const { healthQuote } = useSelector(selectHealthQuoteBuyRoute);
  useEffectOnce(() => {
    const payload: HealthQuoteFindPayload = params;
    dispatch(healthQuoteFind(payload));
  });
  return healthQuote;
};

export const useHealthQuoteFetch = () => {
  const dispatch = useDispatch();
  const orderNumber = useRouteParam('orderNumber') as string;
  const { healthQuote } = useSelector(selectHealthQuoteBuyRoute);
  useEffectOnce(() => {
    const payload: HealthQuoteFetchPayload = { orderNumber };
    dispatch(healthQuoteFetch(payload));
  });
  return healthQuote;
};
